/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { AccountEnabledPatchForm } from '../model/models';
import { CittadinoListFilter } from '../model/models';
import { CittadinoSincronizzazioneKeycloakDTO } from '../model/models';
import { ExceptionResponseDTO } from '../model/models';
import { GenericResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelCittadinoBackofficeRowDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface AnonimizzaCittadinoRequestParams {
    userId: string;
}

export interface AvviaResetPasswordCittadinoRequestParams {
    userId: string;
}

export interface ForzaStatoAccountCittadinoRequestParams {
    userId: string;
    accountEnabledPatchForm: AccountEnabledPatchForm;
}

export interface GetResetPasswordLinkCittadinoRequestParams {
    userId: string;
}

export interface GetVerificationLinkCittadinoRequestParams {
    userId: string;
}

export interface ListCittadiniRequestParams {
    filter: CittadinoListFilter;
    pageable: Pageable;
}

export interface ReinviaVerificaCittadinoRequestParams {
    userId: string;
}

export interface SincronizzaKeycloakCittadinoRequestParams {
    userId: string;
}


export interface CittadiniServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Anonimizza l\&#39;account di un cittadino (SUPERADMIN).
     * Per le richieste di cancellazione ricevute fuori dall\&#39;app (PEC, sportello): il canale ordinario resta il self-service del cittadino. Azzera i dati personali di identita\&#39; e profilo, disabilita l\&#39;account in Keycloak e revoca le sessioni; le pratiche presentate NON vengono cancellate e restano consultabili. Operazione IRREVERSIBILE: l\&#39;account non e\&#39; recuperabile. L\&#39;operatore che la esegue viene tracciato. 404 privacy se il target non e\&#39; un CITTADINO.
     * @endpoint post /api/v1/gestione/cittadini/{user_id}/anonimizza
* @param requestParameters
     */
    anonimizzaCittadino(requestParameters: AnonimizzaCittadinoRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Avvia il reset password per un cittadino (SUPERADMIN).
     * Riusa resetUserPassword (invia l\&#39;email col doppio link). 404 privacy se target non CITTADINO; 400 se il cittadino non ha email.
     * @endpoint post /api/v1/gestione/cittadini/{user_id}/reset-password
* @param requestParameters
     */
    avviaResetPasswordCittadino(requestParameters: AvviaResetPasswordCittadinoRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Forza l\&#39;abilitazione/disabilitazione dell\&#39;accesso di un cittadino (SUPERADMIN).
     * Sospende o ripristina l\&#39;accesso scrivendo lo stato sia in locale sia in Keycloak, e revocando le sessioni attive sulla disabilitazione. L\&#39;operazione e\&#39; atomica: se Keycloak non applica la scrittura viene restituito 400 e lo stato locale resta invariato, per non lasciare divergenza tra i due sistemi. Reversibile (a differenza dell\&#39;anonimizzazione). 404 privacy se target non CITTADINO; 409 se l\&#39;account e\&#39; anonimizzato.
     * @endpoint put /api/v1/gestione/cittadini/{user_id}/stato-account
* @param requestParameters
     */
    forzaStatoAccountCittadino(requestParameters: ForzaStatoAccountCittadinoRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Genera il link di reset password per un cittadino (SUPERADMIN).
     * Verbo POST per side-effect server-side (genera/persiste un JTI). 404 privacy se target non CITTADINO.
     * @endpoint post /api/v1/gestione/cittadini/{user_id}/get-reset-password-link
* @param requestParameters
     */
    getResetPasswordLinkCittadino(requestParameters: GetResetPasswordLinkCittadinoRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Genera il link di verifica email per un cittadino (SUPERADMIN).
     * Verbo POST per side-effect server-side (genera/persiste un JTI). 404 privacy se target non CITTADINO.
     * @endpoint post /api/v1/gestione/cittadini/{user_id}/get-verification-link
* @param requestParameters
     */
    getVerificationLinkCittadino(requestParameters: GetVerificationLinkCittadinoRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Lista paginata dei cittadini (SUPERADMIN).
     * Filtri opzionali: q (email/nome/cognome), account_enabled, anonimizzato (true &#x3D; solo account eliminati, false &#x3D; solo account attivi, assente &#x3D; tutti). Default sort: email ASC, size 20. Ogni riga porta lo stato account leggibile e la data di eventuale eliminazione (anonimizzato_il).
     * @endpoint get /api/v1/gestione/cittadini
* @param requestParameters
     */
    listCittadini(requestParameters: ListCittadiniRequestParams, extraHttpRequestParams?: any): Observable<PagedModelCittadinoBackofficeRowDTO>;

    /**
     * Reinvia l\&#39;email di verifica a un cittadino (SUPERADMIN).
     * Riusa retryVerification. 404 privacy se target non CITTADINO; 400 se il cittadino non ha email (accesso via identità digitale).
     * @endpoint post /api/v1/gestione/cittadini/{user_id}/reinvia-verifica
* @param requestParameters
     */
    reinviaVerificaCittadino(requestParameters: ReinviaVerificaCittadinoRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Riallinea lo stato account di un cittadino leggendolo da Keycloak (SUPERADMIN).
     * Serve quando l\&#39;account e\&#39; stato disabilitato o bloccato direttamente in Keycloak e il gestionale non ne ha contezza. Keycloak e\&#39; l\&#39;autorita\&#39; (decide chi accede davvero), quindi l\&#39;allineamento e\&#39; KC -&gt; locale. Riporta il prima/dopo e lo stato del blocco per tentativi falliti, che non e\&#39; rispecchiato da nessuna colonna locale. Il blocco per tentativi NON viene rimosso qui: lo sblocco e\&#39; un\&#39;azione separata. 404 privacy se target non CITTADINO.
     * @endpoint post /api/v1/gestione/cittadini/{user_id}/sincronizza-keycloak
* @param requestParameters
     */
    sincronizzaKeycloakCittadino(requestParameters: SincronizzaKeycloakCittadinoRequestParams, extraHttpRequestParams?: any): Observable<CittadinoSincronizzazioneKeycloakDTO>;

}
